module.exports = __webpack_public_path__ + "static/media/logo_white.72c38f6d.svg";